// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import {
  CREATE_VENDOR,
  DELETE_VENDOR,
  EDIT_VENDOR,
  GET_DETAIL_VENDOR,
  GET_LIST_VENDORS,
} from '~/utils/constants/actionType';
import {
  IFormVendor,
  IPayloadEditVendor,
  IQueryParamDetailVendor,
  IQueryParamVendors,
} from '~/utils/interface/vendors';
import vendorsApi from '~/apis/vendors';

export const getListVendors = createAsyncThunk(
  GET_LIST_VENDORS,
  async (params: IQueryParamVendors, { rejectWithValue }) => {
    try {
      const resp = await vendorsApi.getListVendors(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createVendor = createAsyncThunk(CREATE_VENDOR, async (body: IFormVendor, { rejectWithValue }) => {
  try {
    const resp = await vendorsApi.createVendor(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const editVendor = createAsyncThunk(EDIT_VENDOR, async (payload: IPayloadEditVendor, { rejectWithValue }) => {
  try {
    const resp = await vendorsApi.editVendor(payload);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailVendor = createAsyncThunk(
  GET_DETAIL_VENDOR,
  async (params: IQueryParamDetailVendor, { rejectWithValue }) => {
    try {
      const resp = await vendorsApi.getDetailVendor(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteVendor = createAsyncThunk(DELETE_VENDOR, async (vendorId: string, { rejectWithValue }) => {
  try {
    const resp = await vendorsApi.deleteVendor(vendorId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
